export default "__VITE_ASSET__b5886bee__"